<n-panel height="100%">
    <p class="mb-20">{{i18n.tip}}</p>
    <form [formGroup]="vm" [errorMessage]="errorMessage" [simpleMode]="isSimpleMode"
        [ngClass]="{ 'form-width-simple': isSimpleMode }">
        <n-form-item [label]="i18n.primaryDnsIpLab">
            <div class="interval-10">
                <input type="text" id="primaryDnsIpField" pInputText formControlName="primaryDnsIp"
                    [placeholder]="i18n.ipTip" />
                <button pButton id="testPrimaryDnsIpBtn" type="text" [label]="i18n.testBtn"
                    [disabled]="!vm.get('primaryDnsIp')['_pendingValue']" (click)="test('primaryDnsIp')">
                </button>
            </div>
        </n-form-item>
        <n-form-item [label]="i18n.standbyDnsIp1Lab">
            <div class="interval-10">
                <input type="text" id="standbyDnsIp1Field" pInputText formControlName="standbyDnsIp1"
                    [placeholder]="i18n.ipTip" />
                <button pButton id="testStandbyDnsIp1IpBtn" type="text" [label]="i18n.testBtn"
                    [disabled]="!vm.get('standbyDnsIp1')['_pendingValue']" (click)="test('standbyDnsIp1')">
                </button>
            </div>
        </n-form-item>
        <n-form-item [label]="i18n.standbyDnsIp2Lab">
            <div class="interval-10">
                <input type="text" id="standbyDnsIp2Field" pInputText formControlName="standbyDnsIp2"
                    [placeholder]="i18n.ipTip" />
                <button pButton id="testStandbyDnsIp2IpBtn" type="text" [label]="i18n.testBtn"
                    [disabled]="!vm.get('standbyDnsIp2')['_pendingValue']" (click)="test('standbyDnsIp2')">
                </button>
            </div>
        </n-form-item>
        <n-form-item [labelHide]="true">
            <button pButton id="testAllBtn" type="button" [label]="i18n.testAllBtn"
                [disabled]="!vm.get('primaryDnsIp')['_pendingValue'] && !vm.get('standbyDnsIp1')['_pendingValue'] && !vm.get('standbyDnsIp2')['_pendingValue']"
                (click)="testAll()">
            </button>
        </n-form-item>
    </form>
    <ng-container>
        <div class="title-md mt-32 mb-20">{{i18n.domainTitle}}</div>
        <n-tip class="mb-20">
            <span>{{i18n.domainNameMsg}}</span>
        </n-tip>
        <!-- DNS域名 -->
        <form [formGroup]="dnsVm" [class.mt-8]="simpleModeStyle"
            [errorMessage]="dnsErrorMsg">
            <n-data-table #dt
                class="dnsTable"
                id="domainName-table"
                [data]="dnsListData"
                [config]="dnsTableConfig"
                [columnDefs]="dnsTableColumnDefs">
                <!-- 域名 -->
                <ng-template nTemplate
                    [meta]="{'field': 'domainName'}"
                    let-data="rowData"
                    let-rowIndex="rowIndex">
                    <n-form-item errorStyle="tooltip">
                        <input type="text"
                            class="user-info"
                            [ngClass]="{'simple-user-info': isSimpleMode}"
                            nInput
                            [id]="'create-domainName'+rowIndex"
                            [formControlName]="'domainName'+dnsListData[rowIndex]['number']"
                            [(ngModel)]="dnsListData[rowIndex]['domainName']">
                    </n-form-item>
                </ng-template>
                <ng-template nTemplate
                    [meta]="{'field': 'operation'}"
                    let-data="rowData"
                    let-rowIndex="rowIndex">
                    <button class="icon-btn mr-20"
                        [disabled]="rowIndex === 0"
                        (click)="moveUpDns(rowIndex, data)">
                        <svg class="icon">
                            <use xlink:href="#app-icon-up">
                            </use>
                        </svg>
                    </button>
                    <button class="icon-btn mr-20"
                        [disabled]="rowIndex === dnsListData.length - 1"
                        (click)="moveDownDns(rowIndex, data)">
                        <svg class="icon">
                            <use xlink:href="#app-icon-down">
                            </use>
                        </svg>
                    </button>
                    <button class="icon-btn"
                        (click)="deleteDns(rowIndex)">
                        <svg class="icon">
                            <use xlink:href="#icon-delete">
                            </use>
                        </svg>
                    </button>
                </ng-template>
            </n-data-table>
        </form>
        <div class="addDns" [ngClass]="{'disable': dnsListData.length === this.maxDnsNum}">
            <svg class="icon addIcon" (click)="addDnsListData()">
                <use xlink:href="#app-icon-plus">
                </use>
            </svg>
            <span class="addButton" (click)="addDnsListData()">{{i18n.addButton}}</span>
        </div>
    </ng-container>

    <n-footer *ngIf="!inSlideWindow">
        <button pButton id="saveBtn" class="ui-btn-primary" [label]="i18n.saveBtn" (click)="onSave()">
        </button>
        <button pButton id="cancelBtn" [label]="i18n.cancelBtn" (click)="onCancel()">
        </button>
    </n-footer>
</n-panel>
